<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  <div class=" col-8 mb-3 message-container blue-fill">
    <mwp-text-translate text="Review your information below. If you need to make changes, and editing isn't available, contact your benefits or payroll department for assistance.
" jsonKey="profileNote" />
  </div>
  @if (displayForm) {
  <div>
    <mwp-profile-form [member]="member" [enablePopupButtons]="true" (emitContinue)="displaySaveWarning()" (emitSave)="save($event)" (emitDelete)="deleteAccount()" (emitReload)="reload()" />
  </div>
  }
</div>